import { render, staticRenderFns } from "./Cobranca.vue?vue&type=template&id=0bedfcd2"
import script from "./Cobranca.vue?vue&type=script&lang=js"
export * from "./Cobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports